var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rating-section"},[_c('div',{staticClass:"rating"},_vm._l((5),function(i){return _c('span',{key:i,class:{'rating__current': _vm.rating >= i},style:({width: _vm.size + 'px', height: _vm.size + 'px'})})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }